<template>
  <v-container class="modern-mission-container" fluid ma-0 pa-0>
    <!-- Modern Header -->
    <div class="modern-mission-header">
      <div class="header-background">
        <div class="header-circle header-circle-1"></div>
        <div class="header-circle header-circle-2"></div>
        <div class="header-circle header-circle-3"></div>
      </div>
      <div class="header-content-wrapper">
        <div class="header-icon-wrapper">
          <v-icon size="56" color="white">mdi-target</v-icon>
        </div>
        <div class="header-text-content">
          <h1 class="modern-mission-title">Our Mission & Vision</h1>
          <p class="modern-mission-subtitle">
            <v-icon small color="white" class="mr-1">mdi-heart</v-icon>
            Preserving Tamil culture and heritage for future generations
          </p>
        </div>
      </div>
    </div>

    <v-row class="ma-0 px-4 py-6" justify="center">
      <v-col cols="12" md="10" lg="9">
        <!-- Organization Info Card -->
        <v-card class="modern-org-card mb-6" elevation="0">
          <div class="org-card-header">
            <div class="org-icon-wrapper">
              <v-icon color="white" size="32">mdi-certificate</v-icon>
            </div>
            <div class="org-header-text">
              <h2 class="org-title">Charlotte Tamil Sangam</h2>
              <p class="org-subtitle">A Registered, Non-Profit, IRS Tax-Exempt 501(c)(3) Organization</p>
            </div>
          </div>
        </v-card>

        <!-- Mission Stats Cards -->
        <v-row class="mb-6">
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-card class="modern-mission-stats-card culture-card" elevation="0">
              <div class="mission-stats-content">
                <div class="mission-stats-icon culture-icon">
                  <v-icon color="white" size="32">mdi-book-open-variant</v-icon>
                </div>
                <div class="mission-stats-label">Tamil Language & Arts</div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-card class="modern-mission-stats-card youth-card" elevation="0">
              <div class="mission-stats-content">
                <div class="mission-stats-icon youth-icon">
                  <v-icon color="white" size="32">mdi-account-group</v-icon>
                </div>
                <div class="mission-stats-label">Youth Engagement</div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-card class="modern-mission-stats-card arts-card" elevation="0">
              <div class="mission-stats-content">
                <div class="mission-stats-icon arts-icon">
                  <v-icon color="white" size="32">mdi-music</v-icon>
                </div>
                <div class="mission-stats-label">Arts & Music</div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-card class="modern-mission-stats-card community-card" elevation="0">
              <div class="mission-stats-content">
                <div class="mission-stats-icon community-icon">
                  <v-icon color="white" size="32">mdi-handshake</v-icon>
                </div>
                <div class="mission-stats-label">Community Building</div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Mission Objectives Section -->
        <div class="modern-objectives-section">
          <div class="objectives-section-header">
            <div class="section-icon-badge">
              <v-icon color="white" size="24">mdi-bullseye-arrow</v-icon>
            </div>
            <h2 class="objectives-section-title">Our Core Objectives</h2>
          </div>

          <v-row>
            <v-col
              v-for="(objective, index) in objectives"
              :key="index"
              cols="12"
              md="6"
              class="pa-2"
            >
              <v-card class="modern-objective-card" elevation="0">
                <div class="objective-card-glow" :class="objective.glowClass"></div>
                <div class="objective-card-content">
                  <div class="objective-number" :class="objective.numberClass">
                    {{ index + 1 }}
                  </div>
                  <div class="objective-icon-wrapper" :class="objective.iconClass">
                    <v-icon color="white" size="28">{{ objective.icon }}</v-icon>
                  </div>
                  <div class="objective-text">
                    <h3 class="objective-title">{{ objective.title }}</h3>
                    <p class="objective-description">{{ objective.description }}</p>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <!-- Vision Statement -->
        <v-card class="modern-vision-card mt-6" elevation="0">
          <div class="vision-card-header">
            <div class="vision-icon-wrapper">
              <v-icon color="white" size="36">mdi-eye</v-icon>
            </div>
            <h2 class="vision-title">Our Vision</h2>
          </div>
          <div class="vision-content">
            <p class="vision-text">
              To be the leading organization in preserving and promoting Tamil language, culture, and heritage
              in the Charlotte region, while fostering a strong sense of community and cultural identity among
              Tamil people of all ages. We envision a future where our traditions thrive, our youth are engaged,
              and our community continues to grow stronger together.
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
  export default {
    data () {
      return {
        objectives: [
          {
            title: 'Tamil Language & Arts',
            description: 'Cultivate, promote and develop the Tamil language and arts. Promote Tamil literary reading and discussion.',
            icon: 'mdi-book-open-variant',
            iconClass: 'culture-icon-obj',
            numberClass: 'number-culture',
            glowClass: 'glow-culture'
          },
          {
            title: 'Cultural Heritage',
            description: 'Spread the Tamil culture and instill within our upcoming youngsters the values and essence of Tamil.',
            icon: 'mdi-temple-hindu',
            iconClass: 'heritage-icon-obj',
            numberClass: 'number-heritage',
            glowClass: 'glow-heritage'
          },
          {
            title: 'Youth Engagement',
            description: 'Encourage the youth to organize and participate in voluntary activities.',
            icon: 'mdi-account-group',
            iconClass: 'youth-icon-obj',
            numberClass: 'number-youth',
            glowClass: 'glow-youth'
          },
          {
            title: 'Arts & Performance',
            description: 'Promote Tamil art, music, dances and drama.',
            icon: 'mdi-music',
            iconClass: 'arts-icon-obj',
            numberClass: 'number-arts',
            glowClass: 'glow-arts'
          },
          {
            title: 'Leadership & Honor',
            description: 'Invite and honor intellectual leaders.',
            icon: 'mdi-trophy',
            iconClass: 'leadership-icon-obj',
            numberClass: 'number-leadership',
            glowClass: 'glow-leadership'
          },
          {
            title: 'Festivals & Traditions',
            description: 'Celebrate Tamil functions and encourage youngsters to participate, use these avenues to teach them the significance of our festivals and rituals.',
            icon: 'mdi-calendar-star',
            iconClass: 'festival-icon-obj',
            numberClass: 'number-festival',
            glowClass: 'glow-festival'
          },
          {
            title: 'Community Collaboration',
            description: 'Interface with other organizations to promote cultural understanding.',
            icon: 'mdi-handshake',
            iconClass: 'community-icon-obj',
            numberClass: 'number-community',
            glowClass: 'glow-community'
          }
        ]
      }
    }
  }
</script>

<style scoped lang="scss">
* {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}

/* Container */
.modern-mission-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;
  min-height: 100vh !important;
}

/* Modern Header */
.modern-mission-header {
  position: relative !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  padding: 50px 24px !important;
  overflow: hidden !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
}

.header-background {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  overflow: hidden !important;
}

.header-circle {
  position: absolute !important;
  border-radius: 50% !important;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%) !important;
}

.header-circle-1 {
  width: 400px !important;
  height: 400px !important;
  top: -200px !important;
  right: -100px !important;
}

.header-circle-2 {
  width: 300px !important;
  height: 300px !important;
  bottom: -150px !important;
  left: -50px !important;
}

.header-circle-3 {
  width: 200px !important;
  height: 200px !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  opacity: 0.5 !important;
}

.header-content-wrapper {
  position: relative !important;
  z-index: 2 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 24px !important;
  flex-wrap: wrap !important;
}

.header-icon-wrapper {
  width: 80px !important;
  height: 80px !important;
  border-radius: 20px !important;
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(20px) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.15),
    inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
}

.header-text-content {
  text-align: center !important;
}

.modern-mission-title {
  font-size: 42px !important;
  font-weight: 800 !important;
  color: white !important;
  margin: 0 !important;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
  letter-spacing: -0.5px !important;
}

.modern-mission-subtitle {
  font-size: 16px !important;
  color: rgba(255, 255, 255, 0.95) !important;
  margin: 8px 0 0 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
}

/* Organization Card */
.modern-org-card {
  border-radius: 18px !important;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.9) 100%) !important;
  backdrop-filter: blur(30px) !important;
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  box-shadow:
    0 12px 32px rgba(0, 0, 0, 0.12),
    0 4px 12px rgba(0, 0, 0, 0.08),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
  overflow: hidden !important;
  position: relative !important;
}

.modern-org-card::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 5px !important;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%) !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 3s ease infinite !important;
}

.org-card-header {
  padding: 32px !important;
  display: flex !important;
  align-items: center !important;
  gap: 20px !important;
}

.org-icon-wrapper {
  width: 72px !important;
  height: 72px !important;
  border-radius: 16px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 8px 20px rgba(102, 126, 234, 0.4),
    inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
  flex-shrink: 0 !important;
}

.org-header-text {
  flex: 1 !important;
}

.org-title {
  font-size: 28px !important;
  font-weight: 700 !important;
  color: #1f2937 !important;
  margin: 0 0 8px 0 !important;
  line-height: 1.2 !important;
}

.org-subtitle {
  font-size: 15px !important;
  font-weight: 600 !important;
  color: #667eea !important;
  margin: 0 !important;
  line-height: 1.4 !important;
}

/* Mission Stats Cards */
.modern-mission-stats-card {
  border-radius: 16px !important;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.9) 100%) !important;
  backdrop-filter: blur(30px) !important;
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.1),
    0 4px 12px rgba(0, 0, 0, 0.06),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
}

.modern-mission-stats-card::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 4px !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 3s ease infinite !important;
}

.culture-card::before {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%) !important;
}

.youth-card::before {
  background: linear-gradient(90deg, #4CAF50 0%, #388E3C 50%, #81C784 100%) !important;
}

.arts-card::before {
  background: linear-gradient(90deg, #FF9800 0%, #F57C00 50%, #FFB74D 100%) !important;
}

.community-card::before {
  background: linear-gradient(90deg, #2196F3 0%, #1976D2 50%, #64B5F6 100%) !important;
}

.modern-mission-stats-card:hover {
  transform: translateY(-8px) scale(1.03) !important;
  box-shadow:
    0 16px 40px rgba(0, 0, 0, 0.15),
    0 8px 16px rgba(0, 0, 0, 0.1),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
}

.mission-stats-content {
  padding: 24px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 12px !important;
  text-align: center !important;
}

.mission-stats-icon {
  width: 64px !important;
  height: 64px !important;
  border-radius: 14px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.15),
    inset 0 1px 2px rgba(255, 255, 255, 0.3) !important;
  position: relative !important;
  overflow: hidden !important;
}

.mission-stats-icon::before {
  content: '' !important;
  position: absolute !important;
  top: -50% !important;
  left: -50% !important;
  width: 200% !important;
  height: 200% !important;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.3), transparent) !important;
  transform: rotate(45deg) !important;
  animation: shimmer 3s infinite !important;
}

.culture-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.youth-icon {
  background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%) !important;
}

.arts-icon {
  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%) !important;
}

.community-icon {
  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%) !important;
}

.mission-stats-label {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #1f2937 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  line-height: 1.3 !important;
}

/* Objectives Section */
.modern-objectives-section {
  margin-top: 32px !important;
}

.objectives-section-header {
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
  margin-bottom: 24px !important;
  padding: 0 8px !important;
}

.section-icon-badge {
  width: 48px !important;
  height: 48px !important;
  border-radius: 12px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 4px 12px rgba(102, 126, 234, 0.4),
    inset 0 1px 2px rgba(255, 255, 255, 0.3) !important;
}

.objectives-section-title {
  font-size: 28px !important;
  font-weight: 700 !important;
  color: #1f2937 !important;
  margin: 0 !important;
}

/* Objective Cards */
.modern-objective-card {
  border-radius: 16px !important;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.9) 100%) !important;
  backdrop-filter: blur(30px) !important;
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.1),
    0 4px 12px rgba(0, 0, 0, 0.06),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
  height: 100% !important;
}

.objective-card-glow {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 4px !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 3s ease infinite !important;
}

.glow-culture {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%) !important;
}

.glow-heritage {
  background: linear-gradient(90deg, #9C27B0 0%, #7B1FA2 50%, #BA68C8 100%) !important;
}

.glow-youth {
  background: linear-gradient(90deg, #4CAF50 0%, #388E3C 50%, #81C784 100%) !important;
}

.glow-arts {
  background: linear-gradient(90deg, #FF9800 0%, #F57C00 50%, #FFB74D 100%) !important;
}

.glow-leadership {
  background: linear-gradient(90deg, #f44336 0%, #d32f2f 50%, #EF5350 100%) !important;
}

.glow-festival {
  background: linear-gradient(90deg, #2196F3 0%, #1976D2 50%, #64B5F6 100%) !important;
}

.glow-community {
  background: linear-gradient(90deg, #00BCD4 0%, #0097A7 50%, #4DD0E1 100%) !important;
}

.modern-objective-card:hover {
  transform: translateY(-6px) scale(1.02) !important;
  box-shadow:
    0 16px 40px rgba(0, 0, 0, 0.15),
    0 8px 16px rgba(0, 0, 0, 0.1),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
}

.objective-card-content {
  padding: 24px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
  position: relative !important;
}

.objective-number {
  position: absolute !important;
  top: 16px !important;
  right: 16px !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 10px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 18px !important;
  font-weight: 800 !important;
  color: white !important;
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.2),
    inset 0 1px 2px rgba(255, 255, 255, 0.3) !important;
}

.number-culture {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.number-heritage {
  background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%) !important;
}

.number-youth {
  background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%) !important;
}

.number-arts {
  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%) !important;
}

.number-leadership {
  background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%) !important;
}

.number-festival {
  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%) !important;
}

.number-community {
  background: linear-gradient(135deg, #00BCD4 0%, #0097A7 100%) !important;
}

.objective-icon-wrapper {
  width: 64px !important;
  height: 64px !important;
  border-radius: 14px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.15),
    inset 0 1px 2px rgba(255, 255, 255, 0.3) !important;
}

.culture-icon-obj {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.heritage-icon-obj {
  background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%) !important;
}

.youth-icon-obj {
  background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%) !important;
}

.arts-icon-obj {
  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%) !important;
}

.leadership-icon-obj {
  background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%) !important;
}

.festival-icon-obj {
  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%) !important;
}

.community-icon-obj {
  background: linear-gradient(135deg, #00BCD4 0%, #0097A7 100%) !important;
}

.objective-text {
  flex: 1 !important;
}

.objective-title {
  font-size: 18px !important;
  font-weight: 700 !important;
  color: #1f2937 !important;
  margin: 0 0 8px 0 !important;
  line-height: 1.3 !important;
}

.objective-description {
  font-size: 14px !important;
  color: #64748b !important;
  line-height: 1.6 !important;
  margin: 0 !important;
}

/* Vision Card */
.modern-vision-card {
  border-radius: 18px !important;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.9) 100%) !important;
  backdrop-filter: blur(30px) !important;
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  box-shadow:
    0 12px 32px rgba(0, 0, 0, 0.12),
    0 4px 12px rgba(0, 0, 0, 0.08),
    inset 0 2px 4px rgba(255, 255, 255, 1) !important;
  overflow: hidden !important;
  position: relative !important;
}

.modern-vision-card::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 5px !important;
  background: linear-gradient(90deg, #4CAF50 0%, #388E3C 50%, #81C784 100%) !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 3s ease infinite !important;
}

.vision-card-header {
  padding: 32px 32px 16px 32px !important;
  display: flex !important;
  align-items: center !important;
  gap: 20px !important;
}

.vision-icon-wrapper {
  width: 72px !important;
  height: 72px !important;
  border-radius: 16px !important;
  background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 8px 20px rgba(76, 175, 80, 0.4),
    inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
  flex-shrink: 0 !important;
}

.vision-title {
  font-size: 28px !important;
  font-weight: 700 !important;
  color: #1f2937 !important;
  margin: 0 !important;
  line-height: 1.2 !important;
}

.vision-content {
  padding: 16px 32px 32px 32px !important;
}

.vision-text {
  font-size: 16px !important;
  color: #4b5563 !important;
  line-height: 1.8 !important;
  margin: 0 !important;
  padding: 20px !important;
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.05) 0%, rgba(56, 142, 60, 0.05) 100%) !important;
  border-radius: 12px !important;
  border-left: 4px solid #4CAF50 !important;
}

/* Animations */
@keyframes gradientFlow {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .modern-mission-title {
    font-size: 36px !important;
  }

  .modern-mission-subtitle {
    font-size: 14px !important;
  }

  .org-title,
  .vision-title,
  .objectives-section-title {
    font-size: 24px !important;
  }

  .org-subtitle {
    font-size: 14px !important;
  }

  .org-card-header,
  .vision-card-header {
    padding: 24px !important;
  }

  .vision-content {
    padding: 12px 24px 24px 24px !important;
  }

  .objective-title {
    font-size: 16px !important;
  }

  .objective-description {
    font-size: 13px !important;
  }
}

@media (max-width: 600px) {
  .modern-mission-header {
    padding: 40px 16px !important;
  }

  .header-icon-wrapper {
    width: 64px !important;
    height: 64px !important;
  }

  .modern-mission-title {
    font-size: 28px !important;
  }

  .modern-mission-subtitle {
    font-size: 13px !important;
  }

  .org-card-header {
    flex-direction: column !important;
    text-align: center !important;
    padding: 20px !important;
  }

  .org-icon-wrapper {
    width: 64px !important;
    height: 64px !important;
  }

  .org-title {
    font-size: 20px !important;
  }

  .org-subtitle {
    font-size: 13px !important;
  }

  .mission-stats-content {
    padding: 20px !important;
  }

  .mission-stats-icon {
    width: 56px !important;
    height: 56px !important;
  }

  .mission-stats-label {
    font-size: 12px !important;
  }

  .objectives-section-title {
    font-size: 20px !important;
  }

  .section-icon-badge {
    width: 40px !important;
    height: 40px !important;
  }

  .objective-card-content {
    padding: 20px !important;
  }

  .objective-number {
    width: 36px !important;
    height: 36px !important;
    font-size: 16px !important;
  }

  .objective-icon-wrapper {
    width: 56px !important;
    height: 56px !important;
  }

  .objective-title {
    font-size: 15px !important;
  }

  .objective-description {
    font-size: 13px !important;
  }

  .vision-card-header {
    flex-direction: column !important;
    text-align: center !important;
    padding: 20px !important;
  }

  .vision-icon-wrapper {
    width: 64px !important;
    height: 64px !important;
  }

  .vision-title {
    font-size: 20px !important;
  }

  .vision-content {
    padding: 12px 20px 20px 20px !important;
  }

  .vision-text {
    font-size: 14px !important;
    padding: 16px !important;
  }
}
</style>
